var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 1.25H2.5625C2.1875 1.25 1.9375 1.5 1.9375 1.875V18.125C1.9375 18.5 2.1875 18.75 2.5625 18.75H17.4375C17.8125 18.75 18.0625 18.5 18.0625 18.125V1.875C18.0625 1.5 17.75 1.25 17.4375 1.25ZM16.8125 17.5H3.1875V2.5H16.8125V17.5Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 6.1875H15C15.375 6.1875 15.625 5.9375 15.625 5.5625C15.625 5.1875 15.375 4.9375 15 4.9375H10.625C10.25 4.9375 10 5.1875 10 5.5625C10 5.9375 10.25 6.1875 10.625 6.1875Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 10.625H15C15.375 10.625 15.625 10.375 15.625 10C15.625 9.625 15.375 9.375 15 9.375H10.625C10.25 9.375 10 9.625 10 10C10 10.375 10.25 10.625 10.625 10.625Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 15.0625H15C15.375 15.0625 15.625 14.8125 15.625 14.4375C15.625 14.0625 15.375 13.8125 15 13.8125H10.625C10.25 13.8125 10 14.0625 10 14.4375C10 14.8125 10.25 15.0625 10.625 15.0625Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 16.0625C5.875 16.1875 6 16.25 6.1875 16.25C6.4375 16.25 6.5 16.1875 6.625 16.0625L9.125 13.5625C9.375 13.3125 9.375 12.9375 9.125 12.6875C8.875 12.4375 8.5 12.4375 8.25 12.6875L6.25 14.75L5.4375 13.8125C5.1875 13.5625 4.8125 13.5 4.5625 13.75C4.3125 14 4.25 14.375 4.5 14.625L5.75 16.0625Z",
    fill: "#757575"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 11.625C5.875 11.75 6 11.8125 6.1875 11.8125C6.4375 11.8125 6.5 11.75 6.625 11.625L9.125 9.125C9.375 8.875 9.375 8.5 9.125 8.25C8.875 8 8.5 8 8.25 8.25L6.25 10.3125L5.4375 9.375C5.1875 9.125 4.8125 9.0625 4.5625 9.3125C4.3125 9.5625 4.25 9.9375 4.5 10.1875L5.75 11.625Z",
    fill: "#757575"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 7.25C5.875 7.375 6 7.4375 6.1875 7.4375C6.4375 7.4375 6.5 7.375 6.625 7.25L9.125 4.75C9.375 4.5 9.375 4.125 9.125 3.875C8.875 3.625 8.5 3.625 8.25 3.875L6.25 5.9375L5.4375 5C5.1875 4.75 4.8125 4.6875 4.5625 4.9375C4.3125 5.1875 4.25 5.5625 4.5 5.8125L5.75 7.25Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksIc);
export default __webpack_public_path__ + "static/media/tasks-ic.cdabc832332607dfb66fb29f535dc077.svg";
export { ForwardRef as ReactComponent };